import { styled } from '@mui/material';

import { COLORS } from '~/styles/colors';

interface StyledSmallCardProps {
  $isHovered?: boolean;
}

interface StyledBigCardProps {
  $isHovered?: boolean;
}

export const StyledLayout = styled('div')(() => ({
  overflow: 'hidden',
}));

export const StyledContainer = styled('div')(() => ({
  maxWidth: '1400px',
  width: '100%',
  margin: '0 auto',
  paddingInline: '83px',
  paddingBottom: '100px',
  position: 'relative',
}));

export const StyledSmallCardsContainer = styled('div')(() => ({
  display: 'flex',
  justifyContent: 'center',
  gap: '16px',
  paddingInline: '16px',
  paddingTop: '40px',
  flexWrap: 'wrap',
  transition: 'height 0.4s ease',
  overflow: 'hidden',
  paddingBottom: '16px',
}));

export const StyledSmallCard = styled('div', {
  shouldForwardProp: (prop) => prop !== '$isHovered',
})<StyledSmallCardProps>(() => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  cursor: 'pointer',
  height: '140px',
  width: '102px',
  borderRadius: '20px',
  paddingInline: '12px',
  paddingBlock: '12px',
  gap: '6px',
  boxSizing: 'border-box',
  backgroundColor: COLORS.white,
  border: `2px solid ${COLORS.white}`,
  boxShadow: `0px 0px 20px 0px rgba(0, 0, 0, 0.05)`,
  transition: 'scale 0.3s ease, border 0.3s ease',

  '&:hover': {
    background: '#f3f9fd',
    border: `2px solid ${COLORS.primary}`,
    scale: '1.1',
  },
}));

export const StyledSmallCardIconWrapper = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  height: '70px',
  width: '70px',
  borderRadius: '16px',
  backgroundColor: '#FAFAFA',
  img: {
    height: 'auto',
    width: '46px',
  },
}));

export const StyledBigCardsContainer = styled('div')(() => ({
  display: 'flex',
  flexWrap: 'wrap',
  gap: '16px',
  justifyContent: 'center',
}));

export const StyledBigCard = styled('div', {
  shouldForwardProp: (prop) => prop !== '$isHovered',
})<StyledBigCardProps>(() => ({
  display: 'flex',
  cursor: 'pointer',
  height: '178px',
  minWidth: '300px',
  width: 'calc(33.3% - 11px)',
  borderRadius: '20px',
  padding: '12px',
  gap: '12px',
  boxSizing: 'border-box',
  backgroundColor: COLORS.white,
  border: `2px solid ${COLORS.white}`,
  boxShadow: `0px 0px 20px 0px rgba(0, 0, 0, 0.05)`,
  transition: 'scale 0.3s ease, border 0.3s ease',

  '&:hover': {
    background: '#f3f9fd',
    border: `2px solid ${COLORS.primary}`,
    scale: '1.07',
  },

  '@media (max-width: 1120px)': {
    width: 'calc(50% - 8px)',
  },

  '@media (max-width: 800px)': {
    width: '100%',
  },
}));

export const StyledBigCardImage = styled('img')(() => ({
  width: '126px',
  height: '154px',
  borderRadius: '14px',
  overflow: 'hidden',
  objectFit: 'cover',
}));

export const StyledBigCardIconWrapper = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  height: '38px',
  width: '38px',
  borderRadius: '12px',
  backgroundColor: '#FAFAFA',
  img: {
    height: 'auto',
    width: '20px',
  },
}));
